// extracted by mini-css-extract-plugin
module.exports = {"view":"_8789","image":"_15809","full":"_14767","video":"_18088","button":"_12140","arrow":"_7270"};